import React from "react";
import Section from "./Section";
import SectionHeader from "./SectionHeader";
import ContentCards from "./ContentCards";
import soon from "../assets/soon.png";

function ContentCardsSection(props) {
  return (
    <Section
      color={props.color}
      size={props.size}
      backgroundImage={props.backgroundImage}
      backgroundImageOpacity={props.backgroundImageOpacity}
    >
      <div className="container">
        <SectionHeader
          title={props.title}
          subtitle={props.subtitle}
          size={1}
          spaced={true}
          className="has-text-centered"
        ></SectionHeader>
        <ContentCards
          items={[
            {
              image:
                "https://media.giphy.com/media/j5cZQV3odj9Hv8hWrD/giphy.gif",
              title: "Destined for X Website Redesign",
              body:
                "Deployed on Netlify a redesigned website for my non-profit in 1 week. Worked with my team @destinedforx to scope out new site requirements.",
              githubLink:
                "https://github.com/jasonbasuil/destined-for-x-dot-com",
              demoLink: "https://www.destinedforx.com/",
            },
            {
              image:
                "https://camo.githubusercontent.com/34e9af17fde24494128f9370bded73599b54aeda/68747470733a2f2f6d656469612e67697068792e636f6d2f6d656469612f32744b7a6f7230363836624b583132454e502f67697068792e676966",
              title: "TuneTest",
              body:
                "TuneTest is a fun music guessing game that pulls your Top Tracks andTop Artists from your Spotify account. Play with your friends with the Search feature and test them on their favorite artist's top tracks.",
              githubLink: "https://github.com/jasonbasuil/TuneTest",
              demoLink: "https://player.vimeo.com/video/336705911",
            },
            {
              image:
                "https://camo.githubusercontent.com/f5996c708ad9875bf22d1a9dc31025fc23281e0f/68747470733a2f2f6d656469612e67697068792e636f6d2f6d656469612f336833754e634b70574649454a6f39716c7a2f67697068792e676966",
              title: "EventMatchr",
              body:
                "Event Matcher is a web application that allows users to search for different events nearby and make purchases through Ticketmaster.",
              githubLink: "https://github.com/jasonbasuil/EventMatchr",
              demoLink: "https://player.vimeo.com/video/336883307",
            },
            {
              image:
                "https://camo.githubusercontent.com/64d7d0cf517f54648bb0eb107a28903117a2fe82/68747470733a2f2f6d656469612e67697068792e636f6d2f6d656469612f6f79635a54425479444d7244746231566b572f67697068792e676966",
              title: "CityExplorer",
              body:
                "Create new events, search for events to attend, and view all the attendees for your events.",
              githubLink: "https://github.com/jasonbasuil/CityExplorer",
              demoLink: null,
            },
            {
              image: soon,
              title: "React Native - Mobile App (WIP)",
              body:
                "Diving into mobile development. So far I'm loving it! Check back later! :)  ",
              githubLink: null,
              demoLink: null,
            },
          ]}
        ></ContentCards>
      </div>
    </Section>
  );
}

export default ContentCardsSection;
